export default __webpack_public_path__ + "static/media/3-bm.a04dc273.webp";